import Contextualable from '../../mixins/contextualable'

export default {
  functional: true,
  
  mixins: [Contextualable],

  props: {
    gm: Boolean,
    light: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean,
    round: Boolean,
    small: Boolean,
    tiny: Boolean,
    flipForRtl: Boolean, // indicates that the icon should be flipped horizontally when page direction is rtl
  },

  render (h, { props, data, children }) {
    const icon = props.gm ? 'material-icons' : 'nandos-icons'
    data.staticClass = data.staticClass ? `${icon} icon ${data.staticClass} ` : `${icon} icon `

    const classes = {
      ...Contextualable.computed.$contextualClasses.apply(Object.assign({useContextualTextClasses: true}, props)),
      'icon--light': props.light,
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'icon--round': props.round,
      'icon--small': props.small,
      'icon--tiny': props.tiny,
      'icon--flip-for-rtl': props.flipForRtl,
    }

    data.staticClass += Object.keys(classes).filter(k => classes[k]).join(' ')

    return h('i', data, children)
  }
}
